import { post } from '../request';
import { Iresponse } from '../interface';

// 首页的新闻合集
export const cmsHomePage = (params?: any): Promise<Iresponse> => {
  return post({ url: '/member/web/article/getList', params })
}

// 文章分类
export const  cmsNewsTree = (params?: any): Promise<Iresponse> => {
  return post({ url: '/member/web/category/getTree', params })
}
// 获取文章列表
export const cmsNewsPage = (params?: any): Promise<Iresponse> => {
  params.userId = window.localStorage.getItem('userRole') || ''
  return post({ url: '/member/web/article/page', params })
}
// 获取文章详情
export const cmsNewsDetail = (params?: any): Promise<Iresponse> => {
  return post({ url: '/member/web/article/get', params })
}
// 搜索文章
// export const cmsSearch = (params?: any): Promise<Iresponse> => {
//   return post({ url: '/member/web/article/page', params })
// }
